export default __webpack_public_path__ + "static/media/cl6.2a689a64.webp";